export const translations = {
  en: {
    // Header
    home: "Home",
    company: "Company",
    product: "Product",
    support: "Support",
    contact: "Contact",

    // Home Page
    welcomeTitle: "Welcome To Our Store",
    welcomeSubtitle: "Discover our amazing products",
    welcomeDescription:
      "We provide high-quality products at reasonable prices. View the slideshow to explore featured products and special offers.",
    featuredProducts: "Featured Products",
    products: "Products",
    loading: "Loading slideshow...",
    loadingText: "Loading...",
    noMedia: "No products available to display",
    clickToView: "Click to view product details",
    viewDetailsButton: "View Details →",
    slideNumber: "of",

    // Slogan Section
    slogan1: "Quality Products at Affordable Prices",
    slogan2: "Fast Shipping Worldwide",
    slogan3: "Customer Satisfaction Guaranteed",
    qualityProducts: "Quality Products at Affordable Prices",
    fastShipping: "Fast Shipping Worldwide",
    customerSatisfaction: "Customer Satisfaction Guaranteed",

    // Features Section
    freeShipping: "Free Shipping",
    freeShippingDesc: "Free shipping for orders over 500,000₫",
    authentic: "100% Authentic",
    authenticDesc:
      "Genuine products with international standards and full warranty",
    flexiblePayment: "Flexible Payment",
    flexiblePaymentDesc: "Multiple secure payment methods supported",
    attractiveOffers: "Attractive Offers",
    attractiveOffersDesc: "Many promotional programs every week",

    // Why Choose Us Section
    whyChooseUs: "Why Choose Us?",
    topReputation: "Top Reputation",
    topReputationDesc:
      "Trusted partner of thousands of customers nationwide with 5+ years of experience",
    guaranteedQuality: "Guaranteed Quality",
    guaranteedQualityDesc:
      "Products are thoroughly tested, meeting international quality standards",
    support247: "24/7 Support",
    support247Desc:
      "Professional and enthusiastic consulting team, supporting anytime, anywhere",
    fastDelivery: "Fast Delivery",
    fastDeliveryDesc:
      "Process orders within 24 hours, nationwide delivery 2-5 days",

    // CTA Section
    discoverProducts: "Discover Our Premium Products",
    discoverProductsDesc:
      "Wide range of high-quality technology products waiting for you to discover",
    viewAllProducts: "View All Products →",

    // Product Page
    allProducts: "All Products",
    filterByCategory: "Filter by Category",
    allCategories: "All Categories",
    noProductsFound: "No products found",
    viewDetails: "View Details",
    productCategories: "Categories",

    // Product Detail
    productDetails: "Product Details",
    price: "Price",
    description: "Description",
    specifications: "Specifications",
    addToCart: "Add to Cart",
    buyNow: "Buy Now",
    relatedProducts: "Related Products",
    loadingProduct: "Loading product...",
    productNotFound: "Product not found",

    // Company Page
    aboutUs: "About Us",
    aboutCompany: "About Us",
    companyName: "EFT Application Technology Development Co., Ltd.",
    ourStory: "Our Story",
    ourMission: "Our Mission",
    ourVision: "Our Vision",
    ourValues: "Core Values",
    trustedPartner: "Your trusted partner in technology solutions",
    companyIntro1:
      "EFT Application Technology Development Co., Ltd. is a leading provider of innovative technology solutions and high-quality products. With years of experience in the industry, we are committed to bringing customers the best products and excellent customer service.",
    companyIntro2:
      "Our mission is to provide cutting-edge technology solutions and premium products, meeting diverse customer needs at reasonable prices. We always put customer satisfaction and innovation first.",
    valueQuality: "Quality",
    valueQualityDesc:
      "Genuine products with international standards and full warranty",
    valueReputation: "Reputation",
    valueReputationDesc: "Trusted partner of thousands of customers nationwide",
    valueInnovation: "Innovation",
    valueInnovationDesc: "Continuously improving and developing new products",
    valueDedication: "Dedication",
    valueDedicationDesc: "Caring customer service, 24/7 support",
    ourAchievements: "Our Achievements",
    kuiperProducts: "Quality Products",
    satisfiedCustomers: "Satisfied Customers",
    yearsExperience: "Years of Experience",
    fiveStarRating: "5-Star Rating",
    ourGallery: "Our Gallery",
    readyToExperience: "Ready to experience our products?",
    contactUsToday: "Contact us today for the best consultation and support!",
    viewProducts: "View Products",
    contactNow: "Contact Now",

    // Support Page
    supportCenter: "Support Center",
    howCanWeHelp: "How can we help you?",
    searchSupport: "Search support articles...",
    popularTopics: "Popular Topics",
    readMore: "Read More",
    views: "views",

    // Contact Page
    contactUs: "Contact Us",
    getInTouch: "Get In Touch",
    contactSubtitle:
      "Have questions or concerns? Send us a message and we will respond as soon as possible.",
    yourName: "Your Name",
    yourEmail: "Your Email",
    yourPhone: "Phone",
    subject: "Subject",
    message: "Message",
    sendMessage: "Send Message",
    sending: "Sending...",
    contactInfo: "Contact Information",
    address: "Address",
    phone: "Phone",
    email: "Email",
    successMessage:
      "Your message has been sent successfully! We will respond as soon as possible.",
    errorMessage: "Failed to send message. Please try again later.",
    required: "*",

    // Footer
    quickLinks: "Quick Links",
    followUs: "Follow Us",
    newsletter: "Newsletter",
    subscribeNewsletter: "Subscribe to our newsletter",
    enterEmailNewsletter: "Enter your email",
    subscribe: "Subscribe",
    allRightsReserved: "All rights reserved",
    ourPartners: "Partners",

    // Auth
    login: "Login",
    register: "Register",
    logout: "Logout",
    logoutSuccess: "Logged out successfully!",
    confirmLogout: "Are you sure you want to logout?",
    welcomeBack: "Welcome back!",
    createAccount: "Create new account to shop",
    alreadyHaveAccount: "Already have an account?",
    noAccount: "Don't have an account?",
    signUpNow: "Sign up now",
    rememberMe: "Remember me",
    forgotPassword: "Forgot password?",
    password: "Password",
    confirmPassword: "Confirm Password",
    username: "Username",
    enterEmail: "Enter email",
    enterPassword: "Enter password",
    enterUsername: "Enter username",
    enterPasswordMin: "Enter password (at least 6 characters)",
    reenterPassword: "Re-enter password",
    processing: "Processing...",
    pleaseEnterEmailAndPassword: "Please enter email and password",
    loginFailed: "Login failed. Please try again.",
    pleaseFillAllInfo: "Please fill in all information",
    usernameMinLength: "Username must be at least 3 characters",
    passwordMinLength: "Password must be at least 6 characters",
    passwordNotMatch: "Password confirmation does not match",
    registerFailed: "Registration failed. Please try again.",
    loginNow: "Login now",

    // Shopping Cart & Checkout
    cart: "Cart",
    shoppingCart: "Shopping Cart",
    cartEmpty: "Your cart is empty",
    cartEmptyDesc: "You don't have any products in your cart yet",
    continueShopping: "Continue Shopping",
    quantity: "Quantity",
    subtotal: "Subtotal",
    shipping: "Shipping",
    free: "Free",
    total: "Total",
    checkout: "Checkout",
    proceedToCheckout: "Proceed to Checkout",
    removeFromCart: "Remove",
    remove: "Remove",
    updateCart: "Update Cart",
    freeShippingNote: "You have free shipping!",
    freeShippingProgress: "Add",
    toGetFreeShipping: "more to get free shipping",
    shippingThreshold: "Add more to get free shipping",
    orderSummary: "Order Summary",

    // Checkout
    shippingInfo: "Shipping Information",
    fullName: "Full Name",
    city: "City/Province",
    district: "District",
    ward: "Ward",
    notes: "Notes",
    paymentMethod: "Payment Method",
    cod: "Cash on Delivery (COD)",
    bankTransfer: "Bank Transfer",
    placeOrder: "Place Order",
    orderItems: "Order Items",
    addedToCart: "Added to cart successfully!",
    loginRequired: "Please login to continue!",
    invalidEmail: "Invalid email address",
    invalidPhone: "Invalid phone number (10-11 digits)",
    orderError: "Failed to place order. Please try again.",

    // Order Success
    orderSuccess: "Order Placed Successfully!",
    orderSuccessMessage:
      "Thank you for your order. We have sent a confirmation email to your address.",
    checkEmail: "Please check your email",
    forOrderDetails: "for order details",
    orderDetails: "Order Details",
    orderNumber: "Order Number",
    orderDate: "Order Date",
    status: "Status",
    orderPending: "Pending",
    orderNotFound: "Order not found",

    // Common
    search: "Search",
    searchProducts: "Search products...",
    searchResults: "Search results",
    clearSearch: "Clear search",
    categories: "Categories",
    close: "Close",
    open: "Open",
    menu: "Menu",
    language: "Language",
    english: "English",
    vietnamese: "Vietnamese",
    images: "Images",
    videoGuide: "Video Guide",
    attachments: "Attachments",
    browserNotSupport: "Your browser does not support video.",
  },

  vi: {
    // Header
    home: "Trang chủ",
    company: "Công ty",
    product: "Sản phẩm",
    support: "Hỗ trợ",
    contact: "Liên hệ",

    // Home Page
    welcomeTitle: "Chào Mừng Đến Với Cửa Hàng",
    welcomeSubtitle: "Khám phá những sản phẩm tuyệt vời của chúng tôi",
    welcomeDescription:
      "Chúng tôi cung cấp các sản phẩm chất lượng cao với giá cả hợp lý. Xem slideshow để khám phá các sản phẩm nổi bật và ưu đãi đặc biệt.",
    featuredProducts: "Sản phẩm nổi bật",
    products: "Sản phẩm",
    loading: "Đang tải slideshow...",
    loadingText: "Đang tải...",
    noMedia: "Chưa có sản phẩm nào để hiển thị",
    clickToView: "Click để xem chi tiết sản phẩm",
    viewDetailsButton: "Xem chi tiết →",
    slideNumber: "/",

    // Slogan Section
    slogan1: "Sản Phẩm Chất Lượng Với Giá Cả Phải Chăng",
    slogan2: "Giao Hàng Nhanh Toàn Quốc",
    slogan3: "Cam Kết Hài Lòng Khách Hàng",
    qualityProducts: "Sản Phẩm Chất Lượng Với Giá Cả Phải Chăng",
    fastShipping: "Giao Hàng Nhanh Toàn Quốc",
    customerSatisfaction: "Cam Kết Hài Lòng Khách Hàng",

    // Features Section
    freeShipping: "Miễn Phí Vận Chuyển",
    freeShippingDesc: "Giao hàng miễn phí cho đơn hàng trên 500.000₫",
    authentic: "Chính Hãng 100%",
    authenticDesc:
      "Sản phẩm chính hãng đạt tiêu chuẩn quốc tế, bảo hành đầy đủ",
    flexiblePayment: "Thanh Toán Linh Hoạt",
    flexiblePaymentDesc: "Hỗ trợ nhiều hình thức thanh toán an toàn",
    attractiveOffers: "Ưu Đãi Hấp Dẫn",
    attractiveOffersDesc: "Nhiều chương trình khuyến mãi mỗi tuần",

    // Why Choose Us Section
    whyChooseUs: "Tại Sao Chọn Chúng Tôi?",
    topReputation: "Uy Tín Hàng Đầu",
    topReputationDesc:
      "Đối tác tin cậy của hàng nghìn khách hàng trên toàn quốc với 5+ năm kinh nghiệm",
    guaranteedQuality: "Chất Lượng Đảm Bảo",
    guaranteedQualityDesc:
      "Sản phẩm được kiểm tra kỹ lưỡng, đạt chuẩn chất lượng quốc tế",
    support247: "Hỗ Trợ 24/7",
    support247Desc:
      "Đội ngũ tư vấn chuyên nghiệp, nhiệt tình hỗ trợ mọi lúc mọi nơi",
    fastDelivery: "Giao Hàng Nhanh",
    fastDeliveryDesc: "Xử lý đơn hàng trong 24h, giao hàng toàn quốc 2-5 ngày",

    // CTA Section
    discoverProducts: "Khám Phá Sản Phẩm Cao Cấp",
    discoverProductsDesc:
      "Đa dạng các sản phẩm công nghệ chất lượng cao đang chờ bạn khám phá",
    viewAllProducts: "Xem Tất Cả Sản Phẩm →",

    // Product Page
    allProducts: "Tất cả sản phẩm",
    filterByCategory: "Lọc theo danh mục",
    allCategories: "Tất cả danh mục",
    noProductsFound: "Không tìm thấy sản phẩm",
    viewDetails: "Xem chi tiết",
    productCategories: "Danh mục",

    // Product Detail
    productDetails: "Chi tiết sản phẩm",
    price: "Giá",
    description: "Mô tả",
    specifications: "Thông số kỹ thuật",
    addToCart: "Thêm vào giỏ",
    buyNow: "Mua ngay",
    relatedProducts: "Sản phẩm liên quan",
    loadingProduct: "Đang tải sản phẩm...",
    productNotFound: "Không tìm thấy sản phẩm",

    // Company Page
    aboutUs: "Về chúng tôi",
    aboutCompany: "Về chúng tôi",
    companyName: "Công ty TNHH Phát triển Công nghệ Ứng dụng EFT",
    ourStory: "Câu Chuyện Của Chúng Tôi",
    ourMission: "Sứ mệnh",
    ourVision: "Tầm nhìn",
    ourValues: "Giá Trị Cốt Lõi",
    trustedPartner:
      "Đối tác tin cậy của bạn trong lĩnh vực giải pháp công nghệ",
    companyIntro1:
      "Công ty TNHH Phát triển Công nghệ Ứng dụng EFT là nhà cung cấp hàng đầu các giải pháp công nghệ sáng tạo và sản phẩm chất lượng cao. Với nhiều năm kinh nghiệm trong ngành, chúng tôi cam kết mang đến cho khách hàng những sản phẩm tốt nhất và dịch vụ chăm sóc khách hàng xuất sắc.",
    companyIntro2:
      "Sứ mệnh của chúng tôi là cung cấp các giải pháp công nghệ tiên tiến và sản phẩm cao cấp, đáp ứng nhu cầu đa dạng của khách hàng với giá cả hợp lý. Chúng tôi luôn đặt sự hài lòng của khách hàng và sự đổi mới sáng tạo lên hàng đầu.",
    valueQuality: "Chất Lượng",
    valueQualityDesc:
      "Sản phẩm chính hãng đạt tiêu chuẩn quốc tế, bảo hành đầy đủ",
    valueReputation: "Uy Tín",
    valueReputationDesc:
      "Đối tác tin cậy của hàng nghìn khách hàng trên toàn quốc",
    valueInnovation: "Sáng Tạo",
    valueInnovationDesc: "Không ngừng cải tiến và phát triển sản phẩm mới",
    valueDedication: "Tận Tâm",
    valueDedicationDesc: "Chăm sóc khách hàng tận tình, hỗ trợ 24/7",
    ourAchievements: "Thành Tựu Của Chúng Tôi",
    kuiperProducts: "Sản phẩm chất lượng",
    satisfiedCustomers: "Khách hàng hài lòng",
    yearsExperience: "Năm kinh nghiệm",
    fiveStarRating: "Đánh giá 5 sao",
    ourGallery: "Hình Ảnh Của Chúng Tôi",
    readyToExperience: "Sẵn sàng trải nghiệm sản phẩm của chúng tôi?",
    contactUsToday:
      "Hãy liên hệ với chúng tôi ngay hôm nay để được tư vấn và hỗ trợ tốt nhất!",
    viewProducts: "Xem Sản Phẩm",
    contactNow: "Liên Hệ Ngay",

    // Support Page
    supportCenter: "Trung tâm hỗ trợ",
    howCanWeHelp: "Chúng tôi có thể giúp gì cho bạn?",
    searchSupport: "Tìm kiếm bài viết hỗ trợ...",
    popularTopics: "Chủ đề phổ biến",
    readMore: "Đọc thêm",
    views: "lượt xem",

    // Contact Page
    contactUs: "Liên hệ với chúng tôi",
    getInTouch: "Liên hệ ngay",
    contactSubtitle:
      "Có câu hỏi hoặc thắc mắc? Gửi tin nhắn cho chúng tôi và chúng tôi sẽ phản hồi sớm nhất có thể.",
    yourName: "Tên của bạn",
    yourEmail: "Email của bạn",
    yourPhone: "Điện thoại",
    subject: "Tiêu đề",
    message: "Nội dung",
    sendMessage: "Gửi tin nhắn",
    sending: "Đang gửi...",
    contactInfo: "Thông tin liên hệ",
    address: "Địa chỉ",
    phone: "Điện thoại",
    email: "Email",
    successMessage:
      "Tin nhắn của bạn đã được gửi thành công! Chúng tôi sẽ phản hồi sớm nhất có thể.",
    errorMessage: "Gửi tin nhắn thất bại. Vui lòng thử lại sau.",
    required: "*",

    // Footer
    quickLinks: "Liên kết nhanh",
    followUs: "Theo dõi chúng tôi",
    newsletter: "Bản tin",
    subscribeNewsletter: "Đăng ký nhận bản tin",
    enterEmailNewsletter: "Nhập email của bạn",
    subscribe: "Đăng ký",
    allRightsReserved: "Bản quyền thuộc về",
    ourPartners: "Đối tác",

    // Auth
    login: "Đăng nhập",
    register: "Đăng ký",
    logout: "Đăng xuất",
    logoutSuccess: "Đăng xuất thành công!",
    confirmLogout: "Bạn có chắc muốn đăng xuất?",
    welcomeBack: "Chào mừng bạn quay trở lại!",
    createAccount: "Tạo tài khoản mới để mua sắm",
    alreadyHaveAccount: "Đã có tài khoản?",
    noAccount: "Chưa có tài khoản?",
    signUpNow: "Đăng ký ngay",
    rememberMe: "Ghi nhớ đăng nhập",
    forgotPassword: "Quên mật khẩu?",
    password: "Mật khẩu",
    confirmPassword: "Xác nhận mật khẩu",
    username: "Tên đăng nhập",
    enterEmail: "Nhập email",
    enterPassword: "Nhập mật khẩu",
    enterUsername: "Nhập tên đăng nhập",
    enterPasswordMin: "Nhập mật khẩu (ít nhất 6 ký tự)",
    reenterPassword: "Nhập lại mật khẩu",
    processing: "Đang xử lý...",
    pleaseEnterEmailAndPassword: "Vui lòng nhập email và mật khẩu",
    loginFailed: "Đăng nhập thất bại. Vui lòng thử lại.",
    pleaseFillAllInfo: "Vui lòng điền đầy đủ thông tin",
    usernameMinLength: "Tên đăng nhập phải có ít nhất 3 ký tự",
    passwordMinLength: "Mật khẩu phải có ít nhất 6 ký tự",
    passwordNotMatch: "Mật khẩu xác nhận không khớp",
    registerFailed: "Đăng ký thất bại. Vui lòng thử lại.",
    loginNow: "Đăng nhập ngay",

    // Shopping Cart & Checkout
    cart: "Giỏ hàng",
    shoppingCart: "Giỏ Hàng",
    cartEmpty: "Giỏ hàng trống",
    cartEmptyDesc: "Bạn chưa có sản phẩm nào trong giỏ hàng",
    continueShopping: "Tiếp tục mua sắm",
    quantity: "Số lượng",
    subtotal: "Tạm tính",
    shipping: "Phí vận chuyển",
    free: "Miễn phí",
    total: "Tổng cộng",
    checkout: "Thanh toán",
    proceedToCheckout: "Tiến hành thanh toán",
    removeFromCart: "Xóa",
    remove: "Xóa",
    updateCart: "Cập nhật giỏ hàng",
    freeShippingNote: "Bạn được miễn phí vận chuyển!",
    freeShippingProgress: "Mua thêm",
    toGetFreeShipping: "để được miễn phí vận chuyển",
    shippingThreshold: "Mua thêm để được miễn phí vận chuyển",
    orderSummary: "Tóm tắt đơn hàng",

    // Checkout
    shippingInfo: "Thông tin giao hàng",
    fullName: "Họ và tên",
    city: "Tỉnh/Thành phố",
    district: "Quận/Huyện",
    ward: "Phường/Xã",
    notes: "Ghi chú",
    paymentMethod: "Phương thức thanh toán",
    cod: "Thanh toán khi nhận hàng (COD)",
    bankTransfer: "Chuyển khoản ngân hàng",
    placeOrder: "Đặt hàng",
    orderItems: "Sản phẩm đã đặt",
    addedToCart: "Đã thêm vào giỏ hàng!",
    loginRequired: "Vui lòng đăng nhập để tiếp tục!",
    invalidEmail: "Email không hợp lệ",
    invalidPhone: "Số điện thoại không hợp lệ (10-11 số)",
    orderError: "Đặt hàng thất bại. Vui lòng thử lại.",

    // Order Success
    orderSuccess: "Đặt hàng thành công!",
    orderSuccessMessage:
      "Cảm ơn bạn đã đặt hàng. Chúng tôi đã gửi email xác nhận đến địa chỉ của bạn.",
    checkEmail: "Vui lòng kiểm tra email",
    forOrderDetails: "để xem chi tiết đơn hàng",
    orderDetails: "Chi tiết đơn hàng",
    orderNumber: "Mã đơn hàng",
    orderDate: "Ngày đặt",
    status: "Trạng thái",
    orderPending: "Đang xử lý",
    orderNotFound: "Không tìm thấy đơn hàng",

    // Common
    search: "Tìm kiếm",
    searchProducts: "Tìm kiếm sản phẩm...",
    searchResults: "Kết quả tìm kiếm",
    clearSearch: "Xóa tìm kiếm",
    categories: "Danh mục",
    close: "Đóng",
    open: "Mở",
    menu: "Menu",
    language: "Ngôn ngữ",
    english: "Tiếng Anh",
    vietnamese: "Tiếng Việt",
    images: "Hình ảnh",
    videoGuide: "Video hướng dẫn",
    attachments: "Tài liệu đính kèm",
    browserNotSupport: "Trình duyệt của bạn không hỗ trợ video.",
  },
};

// Hook để sử dụng translations
export const useTranslations = (language) => {
  return translations[language] || translations.vi;
};
